import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isStartClass: 0, //状态0未开始1进行中2已结束3取消
    boardFileId: '',
    classInfo: {},
    streamId: '',//直播流id
    WhiteboardId: '',//白板id
    taskId: '',//录制id，
    isTacher: '',
    newChat: '',
    triangleUserInfo:{},
    reportId:'',
    productOrderId:'',
    isDownMic: false, // 是否下麦
  },
  getters: {
  },
  mutations: {
    changeIsStartClass(state, payload) {
      state.isStartClass = payload
    },
    changeBoardFileId(state, payload) {
      state.boardFileId = payload
    },
    changeClassInfo(state, payload) {
      state.classInfo = payload
    },
    changeStreamId(state, payload) {
      state.streamId = payload
    },
    changeWhiteboardId(state, payload) {
      state.WhiteboardId = payload
    },
    changeTalkId(state, payload) {
      state.taskId = payload
    },
    changeTeacher(state, payload) {
      state.isTacher = payload
    },

    changeChat(state, payload) {
      state.newChat = payload
    },
    changeUserInfo(state, payload) {
      state.triangleUserInfo = payload
    },
    changeReportId(state, payload) {
      state.reportId = payload
    },
    changeProductOrderId(state, payload) {
      state.productOrderId = payload
    },
    changeDownMic(state, payload) {
      state.isDownMic = payload
    },
  },
  actions: {
  },
  modules: {
  },
});
